import { render } from "./TraceTable.vue?vue&type=template&id=4ef2d168"
import script from "./TraceTable.vue?vue&type=script&lang=js"
export * from "./TraceTable.vue?vue&type=script&lang=js"

import "./TraceTable.vue?vue&type=style&index=0&id=4ef2d168&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__